import { patch } from 'bootstrap/load-snabbdom';
import { VNode } from 'snabbdom/vnode';

const TIMEOUT = 300;
const observer = new MutationObserver(mutationHandler);

const BROCKEN_NODES =
	['body', 'blockquote', 'figure', 'td', 'details', 'dialog', 'fieldset', 'section', 'article', 'nav', 'aside'];

let warningTimeout : number;
let container : VNode | HTMLElement | undefined;
let currentH1s : Map<HTMLElement, HTMLElement[]>;
let currentH1Count = -1;

function getContainer() : VNode | HTMLElement {
	if (container) {
		return container;
	}
	container = document.createElement('div');
	container.setAttribute('class', 'sdx-container');
	$('body').prepend(container);

	return container;
}

function getH1() : Map<HTMLElement, HTMLElement[]> {
	const h1s = new Map();
	$('h1').each((_i, el) => {
		const closest = getClosestBrockenNode(el);
		if(closest) {
			if(h1s.has(closest)) {
				h1s.get(closest).push(el);
			} else {
				h1s.set(closest, [el]);
			}
		}
	});

	return h1s;
}

function getClosestBrockenNode(el : HTMLElement) : HTMLElement | null {
	if(!el || !el.parentElement) {

		return null;
	}

	return BROCKEN_NODES.includes(el.parentElement.tagName.toLowerCase()) ? el.parentElement :
		getClosestBrockenNode(el.parentElement);
}

function getH1Count() : number {
	let count = 0;

	if(currentH1s.size === 0) {
		return count;
	}

	// Value is Array
	for (const value of Array.from(currentH1s.values())) {
		count = Array.isArray(value) && value.length > count ? value.length : count;
	}

	return count;
}

function getBody() {
	if (!getH1Count()) {
		return 'Attention, you forgot to define an H1 title.';
	}
	if (getH1Count() > 1) {
		return <span>Attention, you are not allowed to use more then one H1 title on this page, {getH1Count()} H1s were found
			<span className="checkbox">
				<input type="checkbox" name="h1-highlight" id="h1-highlight" value="1" data-role="none"/>
				<label for="h1-highlight">Highlight</label>
			</span>
		</span>;
	}

	return '';
}

function startObserve() {
	// Create an observer instance linked to the callback function
	observer.observe($('body')[0], {attributes: false, childList: true, subtree: true});
}

function closeWarning() {
	container = patch(getContainer(), <div></div>);
}

function toggleWarning() {
	currentH1s = getH1();
	if (currentH1Count === getH1Count()) {
		return;
	}
	currentH1Count = getH1Count();

	// Stop observer before update warning message
	observer.disconnect();
	if (currentH1Count !== 1) {
		$(document).trigger('h1-warning-show');
		container = patch(getContainer(),
			<div className="sdx-container h1-warning-container">
				<div className="notification-header notification--alert notification--open">
					<div className="notification__content">
						<div className="notification__body">
							{getBody()}
						</div>
						<button className="notification__close notification-cancel"
							ariaLabel="Close" on-click={closeWarning}>
							<i className="icon icon-022-close" ariaHidden="true"></i>
						</button>
					</div>
				</div>
			</div>);
		$('.h1-warning-container').on('click', '#h1-highlight', highlightHandler);
	} else {
		container = patch(getContainer(),
			<div className="sdx-container h1-warning-container"></div>);
		$(document).trigger('h1-warning-hide');
	}
	// Start observer after update warning message
	startObserve();
}

function highlightHandler(e : JQuery.ClickEvent) {
	const el = e.target;
	if (el.checked) {
		// Value is Array
		for (const value of Array.from(currentH1s.values())) {
			if(Array.isArray(value) && value.length > 1) {
				value.forEach(h1El => h1El.className += ' h1-warning-highlight');
			}
		}
	} else {
		$('h1').removeClass('h1-warning-highlight');
	}

}

function mutationHandler() {
	if (warningTimeout) {
		clearTimeout(warningTimeout);
	}
	warningTimeout = setTimeout(toggleWarning, TIMEOUT);
}

$(() => {
	if ($('body.h1Warning').length) {
		mutationHandler();
		startObserve();
	}
});




// WEBPACK FOOTER //
// typescript://../clientlibs/js/lib/generic/seo-utils.tsx